import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { useLocation } from 'react-router-dom';
import brand from 'shared/app/model/branding';
import branding from 'shared/app/model/branding';
import { RouterDialog } from 'shared/components/dialogs/router';
export const BillingMainDialog = memo(function BillingMainDialog() {
    const { pathname } = useLocation();
    const getTitle = useCallback((pathname) => {
        if (pathname == '/billing/firmware-h-2000-plus') {
            return 'Купить прошивку ZONT H-2000+';
        }
        if (pathname == '/billing/sockets-03-thermostat') {
            return 'Покупка отопительных функций для ZONT SOCKETS';
        }
        if (pathname.search('/billing/tariff') != -1) {
            return `Тарифы ${branding.name}`;
        }
        return `Оплата услуг ${brand.name}`;
    }, []);
    const sx = useCallback((theme) => ({
        '& .MuiAppBar-root': {
            backgroundColor: pathname.search('/billing/tariff') != -1
                ? theme.palette.mode == 'dark'
                    ? 'transparent'
                    : theme.palette.primary.dark
                : undefined,
        },
    }), [pathname]);
    return (_jsx(ErrorBoundary, { children: _jsx(RouterDialog, { title: getTitle(pathname), maxWidth: "sm", sx: sx }) }));
});
